export default "<div class=\"sign-in\">\n    <app-login></app-login>\n</div>"